import React from 'react'

export const FAQs = () => {
  return (
    <div>FAQs</div>
  )
}
